import React from 'react';
import { Box, BoxProps } from '@chakra-ui/react';
import DOMPurify from 'dompurify';

import './RichTextPreviewHighlight.css'

interface PreviewProps extends BoxProps {
  value: string;
}

const RichTextPreview: React.FC<PreviewProps> = ({ value, ...props }) => {
  const sanitizedHTML = DOMPurify.sanitize(value);

  return (
    <>
      <Box
        className="tiny-math-content"
        dangerouslySetInnerHTML={{ __html: sanitizedHTML }}
        {...props}
      />
    </>
  );
};

export default RichTextPreview;
